import React from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet-async";
import { connect } from "react-redux";
import qs from "qs";

import TopStories from "dashboard/components/TopStories";
import {
  getSection,
  setSection,
  setLastSeen,
} from "actions/navigation";
import {
  getStoriesStream,
  setStoryStream,
} from "actions/storiesStream";
import {
  FRONTEND_ROOT,
  BACKEND_ROOT,
} from "config/constants";
import {
  getLocalItem,
  setLocalItem,
} from "utils/localdb";

class SectionStream extends React.Component {
  constructor(props) {
    super(props);
    this.loadNextPage = this._loadNextPage.bind(this);
  }

  componentDidMount() {
    if (!this.props.section || !this.props.stories || !this.props.stories.length) {
      this.loadStream(this.props);
    } else {
      setLocalItem("lastSeen", this.props.stories[0].id, { expires: 1 });
    }
  }

  componentWillReceiveProps(nextProps) {
    if(this.props.slug !== nextProps.slug || (this.props.section !== nextProps.section && !nextProps.section)) {
      this.loadStream(nextProps);
    }
  }

  componentWillUnmount() {
    // TODO: Remove this. Right now components that are rendered outside this
    // component so we need to unset it in state.
    this.props.setSection(null);
    this.props.setLastSeen(null);
    if (this.props.stories && this.props.stories.length) {
      this.props.setStoryStream([]);
    }
  }

  getStreamParams(props) {
    return {
      stream: props.slug,
      featured_return_id: props.lastSeen || getLocalItem("lastSeen"),
    };
  }

  loadStream(props) {
    this.props.getSection(props.slug);

    // Preserve the lastSeen ID in state when the stream gets loaded so the unread count works.
    this.props.setLastSeen(getLocalItem("lastSeen"));

    return this.props.getStoriesStream(this.getStreamParams(props)).then((action) => {
      // If there is a first article in the payload, set it as the lastSeen param.
      if (action && action.payload && action.payload[0]) {
        setLocalItem("lastSeen", action.payload[0].id, { expires: 1 });
      }
    });
  }

  _loadNextPage(page) {
    return this.props.getStoriesStream({
      page,
      ...this.getStreamParams(this.props),
    }, true);
  }

  render() {
    const queryParams = qs.parse(this.props.location.search.slice(1));

    return (
      <div>
        {(this.props.section && this.props.slug !== "top") && (
          <Helmet>
            <title>{this.props.section.name} - Axios</title>
            <meta property="og:url" content={`${FRONTEND_ROOT}/${this.props.section.slug}/`} />
            <meta property="og:title" content={`${this.props.section.name} on Axios`} />
          </Helmet>
        )}
        {this.props.section && (
          <Helmet>
            <link rel="alternate" type="application/rss+xml" title="Axios" href={`${BACKEND_ROOT}/feed/${this.props.section.slug}/`} />
          </Helmet>
        )}
        <TopStories
          loadNextPage={this.loadNextPage}
          stream={this.props.slug}
          adId={queryParams.adid}
        />
      </div>
    );
  }
}

SectionStream.propTypes = {
  getSection: PropTypes.func.isRequired,
  getStoriesStream: PropTypes.func.isRequired,
  setSection: PropTypes.func,
  setLastSeen: PropTypes.func.isRequired,
  setStoryStream: PropTypes.func.isRequired,
  slug: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  section: state.navigation.data.section,
  lastSeen: state.navigation.data.lastSeen,
  stories: state.storiesStream.results,
});

const mapDispatchToProps = {
  getSection,
  getStoriesStream,
  setSection,
  setLastSeen,
  setStoryStream,
};

export default connect(mapStateToProps, mapDispatchToProps)(SectionStream);
